import React from 'react'
import classNames from 'classnames'
import { OutlinedGeneralAttachment } from '@hose/eui-icons'

export const IMG_REG_PRE = /^(.*)\.(jpg|bmp|gif|ico|pcx|jpeg|png|raw|tga)$/i

export function PreImg({ file, size, className }: any) {
  const icon = (
    <OutlinedGeneralAttachment
      className={classNames('file-img', className)}
      fontSize={size || 12}
      style={{ color: 'var(--eui-icon-n2)' }}
    />
  )
  if (file.key && file.key.startsWith('DP:')) {
    return icon
  }
  const img = file.thumbUrl || file.url
  return (IMG_REG_PRE.test(file.fileName) && img) ? <img
    alt=""
    className={classNames('file-img', className)}
    src={img}
    width={size}
    height={size}
  /> : icon
}

export default PreImg